import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl, mobile_xs } from '../../global/mediaQueryMixin';
interface Props {
  isSearch?: boolean;
  isSearchInputIcon?: boolean;
  isCloseInputIcon?: boolean;
  progress?: number;
  color?: string;
  isKeyboardVisible?: boolean;
}
const Group = styled.div`
  width: 100%;
  max-width: 1022px;
  margin: auto;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  ${mobile_xl(css`
    padding: 8px 0;
    gap: 24px;
  `)}
`;

const Icon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  &.favorite-icon {
    display: none;
  }
  :hover {
    background-color: var(--background-muted);
    border-radius: 4px;
    svg {
      filter: brightness(var(--brightness-value2));
    }
    .star-icon {
      path {
        fill: var(--text-primary);
      }
    }
  }
  ${mobile_xl(css`
    &.favorite-icon {
      display: flex;
    }
    padding: 6px;
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;

const ProjectItem = styled.div<Props>`
  display: flex;
  align-items: center;
  gap: 40px;
  padding: 16px;
  background-color: var(--background-primary);
  border-bottom: 0.5px solid var(--border-primary);
  cursor: pointer;
  :hover {
    border-bottom: 0.5px solid var(--border-primary);
    background: var(--neutral-secondary);
    ${Icon} {
      display: flex;
    }
    .plus-icon {
      border: 2px solid var(--neutral-secondary);
    }
    .avatar {
      border: 2px solid var(--neutral-secondary);
    }
  }
  :last-child {
    border-bottom: none;
  }
  &.admin-project {
    justify-content: space-between;
  }

  ${mobile_xl(css`
    gap: 10px;
    position: relative;
    padding: 11px 16px 12px;
    flex-direction: column;
    align-items: flex-start;
    &.admin-project {
      padding: 8px 16px 15px;
      align-items: center;
      justify-content: space-between;
      gap: 6px;
    }
    :hover {
      .avatar {
        border: 1px solid var(--background-primary);
      }
      .plus-icon {
        border: 1px solid var(--background-primary);
      }
    }
  `)}
`;

const ProjectName = styled.div`
  max-width: 500px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  &.admin-project-name {
    max-width: 640px;
  }
  ${mobile_xl(css`
    gap: 6px;
  `)}
`;

const Title = styled.h1`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
  margin: 0;
  cursor: pointer;
  padding-block: 2px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
  ${mobile_xl(css`
    font-weight: 600;
    padding-block: 0px;
  `)}
`;

const Text = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: 0;
  padding-block: 2px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
  ${mobile_xl(css`
    padding-block: 0px;
  `)}
`;

const Point = styled.div`
  max-width: 180px;
  width: 100%;
  position: relative;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  ${mobile_xl(css`
    max-width: unset;
  `)}
`;

const SmallDiv = styled.small<Props>`
  position: absolute;
  border-radius: 50%;
  background-color: ${(props: Props) => props.color};
  top: 3px;
  width: 10px;
  height: 10px;
  left: 0px;
  ${mobile_xl(css`
    top: 5px;
  `)}
`;

const ProgressStatus = styled.span`
  position: relative;
  ${Typography.body_sm}
  color: var(--text-primary);
  padding-left: 16px;
`;

const AssignGroup1 = styled.div`
  width: 100%;
  ul {
    display: flex;
    flex-wrap: nowrap;
    list-style-type: none;
    padding: 0;
    margin: 0;
    justify-content: flex-end;
  }
  li {
    margin-left: -10px;
  }
  small {
    padding: 5px;
    border-radius: 20px;
    background: var(--text-secondary);
    border: 2px solid var(--background-primary);
  }
  span {
    ${Typography.body_xs_semibold}
    color: var(--text-primary);
  }
  .plus-icon {
    width: 20px;
    height: 20px;
    border-radius: 24px;
    align-items: center;
    justify-content: center;
    color: var(--text-primary);
    display: flex;
    background-color: var(--background-muted);
    ${Typography.body_xs_semibold}
    border: 2px solid var(--background-primary);
    position: relative;
    top: 0;
  }
  ${mobile_xl(css`
    max-width: unset;
    width: max-content;
    &.admin-assign {
      margin-left: 8px;
      ul {
        justify-content: flex-start;
      }
    }
    ul {
      justify-content: flex-end;
    }
    .avatar {
      width: 22px;
      height: 22px;
      border: 1px solid var(--background-primary);
    }
    .plus-icon {
      width: 22px;
      height: 22px;
      padding-bottom: 0;
      border: 1px solid var(--background-primary);
    }
  `)}
`;

const ModalHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 0.5px solid var(--border-primary);
`;

const Headline = styled.h6`
  ${Typography.body_lg_semibold}
  color: var(--text-primary);
  margin: 0;
`;

const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const BottomContent = styled.div<Props>`
  display: flex;
  flex-direction: column;
  ${mobile_xl(css<Props>`
    margin-bottom: ${({ isKeyboardVisible }) => (isKeyboardVisible ? '0' : '58px')};
  `)}
`;
const ProjectList = styled.div`
  border: 0.5px solid var(--border-primary);
  border-radius: 12px;
  background-color: var(--background-secondary);
  margin-bottom: 20px;
  overflow: hidden;
`;
const TitleText = styled.div`
  color: var(--text-primary);
  ${Typography.body_lg_medium}
  ${mobile_xl(css`
    line-height: 20px !important;
  `)}
`;

const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const Div = styled.div`
  display: flex;
  gap: 8px;
  ${mobile_xl(css`
    width: 100%;
    justify-content: space-between;
    gap: 8px;
    align-items: center;
  `)}
`;
const EmptyBox = styled.div`
  display: flex;
  height: calc(100vh - 70px);
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  ${mobile_xl(css`
    height: calc(100vh - 88px);
  `)}
`;
const ShowHideText = styled.div`
  ${Typography.body_md}
  color: var(--text-secondary);
  text-align: center;
  padding-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  span {
    text-decoration: underline;
    cursor: pointer;
  }
  ${mobile_xl(css`
    line-height: 20px;
  `)}
`;
const RightDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  ${mobile_xl(css`
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
  `)}
`;

const BottomHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  ${mobile_xl(css`
    padding-bottom: 8px;
  `)}
`;

const FilterDiv = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-direction: row;
  .active {
    background-color: var(--neutral-secondary);
    border-radius: 34px;
  }
`;

const SVGDiv = styled.div<Props>`
  padding: 5px;
  display: flex;
  align-items: center;
  position: relative;
  :hover {
    cursor: pointer;
    background-color: var(--neutral-secondary);
    border-radius: 34px;
    ${mobile_xl(css`
      background-color: transparent;
    `)}
  }
  .filters-icon-color {
    fill: var(--text-secondary);
  }
  .search-icon {
    fill: var(--text-secondary);
  }
  ${(props: Props) =>
    props.isSearchInputIcon &&
    css`
      position: absolute;
      padding: 5px 5px 5px 8px;
      :hover {
        background-color: transparent;
      }
      .search-icon-active {
        fill: var(--text-primary);
      }
    `}
  ${(props: Props) =>
    props.isCloseInputIcon &&
    css`
      position: absolute;
      right: 0;
      top: 0;
      padding: 4px 4px 4px 5px;
      :hover {
        background-color: transparent;
      }
      .svgIcon {
        stroke: var(--text-secondary);
      }
    `}
`;

const SearchArea = styled.div<Props>`
  position: relative;
  display: flex;
  align-items: center;
  width: ${(props) => (props.isSearch ? '200px' : '26px')};
  transition: width 0.5s ease;
  height: 26px;
  ${mobile_xs(css<Props>`
    width: ${(props) => (props.isSearch ? '164px' : '26px')};
  `)}
`;

const InputArea = styled.input<Props>`
  width: ${(props) => (props.isSearch ? '100%' : '0')};
  border-radius: 6px;
  border: 0.5px solid var(--brand-primary);
  padding: ${(props) => (props.isSearch ? '5px 27px 5px 29px' : '0')};
  ${Typography.body_sm}
  animation: width 0.5s;
  outline: none;
  background: var(--background-primary);
  color: var(--text-primary);
`;

const MoreIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: pointer;
  :hover {
    background-color: var(--background-muted);
    border-radius: 4px;
  }
  ${mobile_xl(css`
    height: unset;
    padding: 6px;
    :hover {
      background-color: transparent;
    }
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;

const MoreOptionSection = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 20px;
  max-width: 140px;
  width: 100%;
  .active {
    background-color: var(--background-muted);
    border-radius: 4px;
  }
  ${mobile_xl(css`
    max-width: 75px;
    width: max-content;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `)}
`;
const JoinButtonSection = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 20px;
  width: 100%;
  ${mobile_xl(css`
    max-width: 100%;
    justify-content: flex-start;
  `)}
`;
const SVGIconDiv = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  .filters-icon-color {
    fill: var(--text-secondary);
    padding: 5px;
    :hover {
      cursor: pointer;
      background-color: var(--neutral-secondary);
      border-radius: 34px;
      ${mobile_xl(css`
        background-color: transparent;
      `)}
    }
  }
`;

const MiddleDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 40px;
  width: 100%;
  max-width: 360px;
  &.admin-project {
    max-width: 170px;
    justify-content: flex-end;
  }
  ${mobile_xl(css`
    max-width: unset;
    flex-direction: row;
    padding-left: 46px;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
    width: -webkit-fill-available;
  `)}
`;

const TitleSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  /* classname is given for avatar text */
  .project-title {
    span {
      ${Typography.body_lg_semibold}
    }
  }
  ${mobile_xl(css`
    gap: 10px;
    .project-title {
      padding-block: 4px 6px;
    }
  `)}
`;

const DivLeftSection = styled.div`
  width: calc(100% - 24px);
  display: flex;
  align-items: center;
  gap: 8px;
  &.admin-project {
    width: 100%;
  }
  ${mobile_xl(css`
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  `)}
`;
const DivRightSection = styled.div`
  width: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  ${mobile_xl(css`
    width: max-content;
  `)}
`;

export {
  Group,
  Container,
  ProjectItem,
  ProjectName,
  Icon,
  Title,
  Text,
  Point,
  AssignGroup1,
  ModalHead,
  Headline,
  BottomContent,
  TopContent,
  ProjectList,
  TitleText,
  LoadingState,
  Div,
  EmptyBox,
  ShowHideText,
  RightDiv,
  BottomHeader,
  FilterDiv,
  SVGDiv,
  SearchArea,
  InputArea,
  MoreIcon,
  MoreOptionSection,
  SVGIconDiv,
  MiddleDiv,
  JoinButtonSection,
  TitleSection,
  DivLeftSection,
  DivRightSection,
  SmallDiv,
  ProgressStatus
};
